const mediaPolicies = {
  Image: {
    fields: {
      uploadItemId: (id = '') => id,
    },
  },
  ImageVariant: {
    keyFields: ['imageId'],
  },
};

export default mediaPolicies;
